import * as PropTypes from 'prop-types';
import { useRef } from 'react';
import { useFela } from 'react-fela';
import { useIntl } from 'react-intl';
import { SearchBox as GoogleMapsSearchBox } from 'react-google-maps/lib/components/places/SearchBox';

import rule from './SearchBox.rule';

const SearchBox = ({ onSearch }) => {
    const { css } = useFela();
    const intl = useIntl();

    const ref = useRef();
    const google = window.google;
    return (
        <GoogleMapsSearchBox
            ref={ref}
            controlPosition={google.maps.ControlPosition.TOP_LEFT}
            onPlacesChanged={() => {
                const places = ref.current.getPlaces();
                if (places && places[0]) {
                    onSearch(places[0]);
                }
            }}
        >
            <input
                type="text"
                placeholder={intl.formatMessage({
                    id: 'maps.googleMap.search.placeholder',
                })}
                className={css(rule)}
            />
        </GoogleMapsSearchBox>
    );
};

SearchBox.propTypes = {
    onSearch: PropTypes.func.isRequired,
};

export default SearchBox;
